// ===================================================
// CLICKSIGN — ASSINATURA DIGITAL / TERMOS E CONTRATOS
// ===================================================
function salvarConfigClicksign(){
  const cfg={...(CACHE.config||{})};
  cfg.clicksignUrl=document.getElementById('cfg-clicksign-url')?.value.trim()||'https://app.clicksign.com/api/v3';
  cfg.clicksignIntegrationMode='firebase';
  cfg.clicksignBackendConfigured=true;
  delete cfg.anaclaraKey;delete cfg.anaclaraSecret;
  DB.setObj('config',cfg);CACHE.config=cfg;
  localStorage.removeItem('clicksign_local_cfg');
  const badge=document.getElementById('cfg-clicksign-badge');
  if(badge){badge.textContent='Backend registrado';badge.style.color='var(--green)';}
  toast('Integração ClickSign registrada. Se ainda não configurou, defina o segredo CLICKSIGN_ACCESS_TOKEN no Firebase antes de enviar.');
}

function clicksignLocalConfig(){
  // Defesa em profundidade: mesmo que 'clicksign_local_cfg' exista no localStorage
  // (config antiga, ou dado sincronizado/copiado de outro perfil), nunca honrar a
  // ponte local fora de localhost — evita que a chave seja usada se a página for
  // aberta em produção/domínio público.
  if(!/^(127\.0\.0\.1|localhost|\[::1\])$/i.test(location.hostname))return{};
  try{return JSON.parse(localStorage.getItem('clicksign_local_cfg')||'{}')||{}}
  catch{return{}}
}
function salvarConfigClicksignLocal(){
  // Guarda técnica, não só aviso: a ponte local só pode ser ativada quando o próprio
  // app está sendo servido de localhost/127.0.0.1. Em produção/SaaS (domínio público),
  // qualquer XSS na página poderia ler e usar essa chave contra o serviço local de
  // quem quer que abrisse a página — então nem deixamos a chave ser gravada.
  if(!/^(127\.0\.0\.1|localhost|\[::1\])$/i.test(location.hostname)){
    toast('A ponte local do ClickSign só pode ser ativada quando o app roda em localhost. Use o modo Firebase/backend em produção.','error');
    return;
  }
  const url=(document.getElementById('cfg-clicksign-local-url')?.value||'http://127.0.0.1:8787').trim().replace(/\/$/,'');
  const key=(document.getElementById('cfg-clicksign-local-key')?.value||'').trim();
  if(!/^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?$/i.test(url)){toast('A ponte local precisa usar http://127.0.0.1 ou http://localhost.','error');return}
  if(key.length<12){toast('Informe a chave da sessão local exibida pelo servidor.','error');return}
  localStorage.setItem('clicksign_local_cfg',JSON.stringify({enabled:true,url,key,updatedAt:new Date().toISOString()}));
  CACHE.config={...(CACHE.config||{}),clicksignIntegrationMode:'local',clicksignBackendConfigured:true};
  const badge=document.getElementById('cfg-clicksign-badge');
  if(badge){badge.textContent='Ponte local ativa';badge.style.color='var(--green)';}
  toast('Modo local ClickSign ativado neste computador. Não usar em operação SaaS/publicada.');
}
function desativarConfigClicksignLocal(){
  localStorage.removeItem('clicksign_local_cfg');
  if(document.getElementById('cfg-clicksign-local-key'))document.getElementById('cfg-clicksign-local-key').value='';
  renderConfig();
  toast('Modo local ClickSign desativado neste computador.');
}
async function testarClicksignLocal(){
  try{await _callClicksignIntegration('health',{});toast('Ponte local ClickSign respondeu.','success')}
  catch(e){toast('Ponte local indisponível: '+(e.message||e),'error')}
}
function _clicksignCfg(){
  const cfg=CACHE.config||{},local=clicksignLocalConfig();
  return {
    url:(cfg.clicksignUrl||'https://app.clicksign.com/api/v3').replace(/\/$/,''),
    backendConfigured:!!cfg.clicksignBackendConfigured||!!local.enabled,
    mode:local.enabled?'local':(cfg.clicksignIntegrationMode||'firebase'),
    localUrl:(local.url||'http://127.0.0.1:8787').replace(/\/$/,''),
    localKey:local.key||''
  };
}

function salvarConfigAnaclara(){return salvarConfigClicksign()}
function _anaclaraCfg(){return _clicksignCfg()}

async function _callMarmorariaFunction(name,payload){
  await window._firebaseReady;
  if(typeof firebase==='undefined'||typeof firebase.functions!=='function')throw new Error('Firebase Functions não carregou.');
  const fn=firebase.app().functions('southamerica-east1').httpsCallable(name);
  const result=await fn(payload||{});
  return result?.data;
}
async function _callClicksignIntegration(name,payload){
  const cfg=_clicksignCfg();
  if(cfg.mode==='local'){
    if(!cfg.localKey)throw new Error('Chave da ponte local não configurada.');
    const response=await fetch(`${cfg.localUrl}/${encodeURIComponent(name)}`,{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Marmoraria-Local-Key':cfg.localKey},
      body:JSON.stringify(payload||{})
    });
    const data=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(data?.message||data?.error||`Ponte local HTTP ${response.status}`);
    return data;
  }
  return _callMarmorariaFunction(name,payload);
}

